/**
 * Mixin used for appointment details
 * @mixin
 * @displayName Appointment Details Mixin
 */
export default {
  data() {
    return {
      appointmentWarehouse: null
    };
  },
  methods: {
    async getAppointmentWarehouse() {
      if (this.appointment?.dock && !this.isPublic) {
        this.appointmentWarehouse = {};
        this.appointmentWarehouse = await this.$store.dispatch(
          'Warehouses/getWarehouseById',
          this.appointment.dock.warehouse.id
        );
      }
    }
  },
  async mounted() {
    await this.getAppointmentWarehouse();
  },
  watch: {
    appointment: {
      async handler() {
        await this.getAppointmentWarehouse();
      },
      immediate: true
    }
  }
};
